// import React from "react";
// import './Footer.css';
// import logo from "../Images/logo.webp";
// import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube, FaWhatsapp } from "react-icons/fa";

// const Footer = () => {
//   return (
//     <>
//       <footer className="footer">
//         <div className="footer-container">
//           {/* Brand + Logo */}
//           <div className="footer-brand">
//             <img src={logo} alt="Garuda Sena Logo" className="footer-logo" />
//             <h3 className="footer-title">Garuda Sena Volunteers</h3>
//             <p className="footer-text" style={{color:'#fff'}}>
//               An initiative of Sri Ashtothara Shatha (108) Chukkala’s Charitable Trust
//             </p>
//             <div className="footer-socials">
//               <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
//               <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
//               <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
//               <a href="https://youtube.com" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
//             </div>
//           </div>

//           {/* Quick Links */}
//           <div className="footer-links">
//             <h4 className="footer-subtitle">Quick Links</h4>
//             <ul className="footer-list">
//               <li><a href="/" className="footer-link">Home</a></li>
//               <li><a href="/about-us" className="footer-link">About</a></li>
//               <li><a href="/join" className="footer-link">Join</a></li>
//               <li><a href="/gallery" className="footer-link">Gallery</a></li>
//             </ul>
//           </div>

//           {/* Policies */}
//           <div className="footer-policies">
//             <h4 className="footer-subtitle">Policies</h4>
//             <ul className="footer-list">
//               <li><a href="/terms" className="footer-link">Terms & Conditions</a></li>
//               <li><a href="/privacy" className="footer-link">Privacy Policy</a></li>
//               <li><a href="/refund" className="footer-link">Refund & Cancellation</a></li>
//             </ul>
//           </div>
//         </div>

//         <p className="footer-bottom">
//           © {new Date().getFullYear()} Garuda Sena Volunteers · All Rights Reserved
//         </p>
//       </footer>

//       {/* ✅ WhatsApp Floating Button */}
//       <a
//         href="https://wa.me/919666159999"
//         className="whatsapp-float"
//         target="_blank"
//         rel="noopener noreferrer"
//         aria-label="Chat on WhatsApp"
//       >
//         <FaWhatsapp className="whatsapp-icon" />
//       </a>
//     </>
//   );
// };

// export default Footer;

import React, { useState, useEffect } from "react";
import './Footer.css';
import logo from "../Images/logo.webp";
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube, FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  const [socialLinks, setSocialLinks] = useState([]);

  // Fetch social links from the API
  useEffect(() => {
    const fetchSocialLinks = async () => {
      try {
        const response = await fetch("https://api.garudasena.org/api/social-links");
        const data = await response.json();
        setSocialLinks(data); // Set the fetched social links
      } catch (error) {
        console.error("Error fetching social links:", error);
      }
    };

    fetchSocialLinks();
  }, []);

  // Map social icons to their corresponding platform
  const socialIcons = {
    Facebook: <FaFacebookF />,
    Instagram: <FaInstagram />,
    Twitter: <FaTwitter />,
    YouTube: <FaYoutube />,
  };

  return (
    <>
      <footer className="footer">
        <div className="footer-container">
          {/* Brand + Logo */}
          <div className="footer-brand">
            <img src={logo} alt="Garuda Sena Logo" className="footer-logo" />
            <h3 className="footer-title">Garuda Sena Volunteers</h3>
            <p className="footer-text" style={{ color: '#fff' }}>
              An initiative of Sri Ashtothara Shatha (108) Chukkala’s Charitable Trust
            </p>
            <div className="footer-socials">
              {/* Render social links dynamically */}
              {socialLinks.map((link) => (
                <a
                  key={link.id}
                  href={link.social_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={link.social_type}
                >
                  {socialIcons[link.social_type]}
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4 className="footer-subtitle">Quick Links</h4>
            <ul className="footer-list">
              <li><a href="/" className="footer-link">Home</a></li>
              <li><a href="/about-us" className="footer-link">About</a></li>
              <li><a href="/enroll" className="footer-link">Join</a></li>
              <li><a href="/gallery" className="footer-link">Gallery</a></li>
            </ul>
          </div>

          {/* Policies */}
          <div className="footer-policies">
            <h4 className="footer-subtitle">Policies</h4>
            <ul className="footer-list">
              <li><a href="/terms" className="footer-link">Terms & Conditions</a></li>
              <li><a href="/privacy" className="footer-link">Privacy Policy</a></li>
              <li><a href="/refund" className="footer-link">Refund & Cancellation</a></li>
            </ul>
          </div>
        </div>

        <p className="footer-bottom">
          © {new Date().getFullYear()} Garuda Sena Volunteers · All Rights Reserved
        </p>
      </footer>

      {/* ✅ WhatsApp Floating Button */}
      <a
        href="https://wa.me/919666159999"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp className="whatsapp-icon" />
      </a>
    </>
  );
};

export default Footer;
